<template>
    <div class="simple-form flex col-2">
        <div class="form-group">
            <div class="form-label">
                <label>名称：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.name}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>编码：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.code}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>业务单元：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.bizUnitName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>等级：</label>
            </div>
            <div class="form-value">
                <span v-if="layoutArea.level == 1">一级</span>
                <span v-if="layoutArea.level == 2">二级</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>描述：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.desc}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>需要控温：</label>
            </div>
            <div class="form-value">
                <span class="font-red" v-if="layoutArea.temperFlag">是</span>
                <span v-else>否</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>温度低值(°c)：</label>
            </div>
            <div class="form-value">
                <span>{{(layoutArea.temperLow || 0).toFixed(2)}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>温度高值(°c)：</label>
            </div>
            <div class="form-value">
                <span>{{(layoutArea.temperHigh || 0).toFixed(2)}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>设备名称：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.temperAffectedDevcTitle}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>设备编码：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.temperAffectedDevcTmpNo}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建人：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.creatorName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建时间：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.createTime}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>已禁用：</label>
            </div>
            <div class="form-value">
                <span class="font-red" v-if="layoutArea.disabled">是</span>
                <span v-else>否</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用人：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.disablerName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用原因：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.disableCause}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用时间：</label>
            </div>
            <div class="form-value">
                <span>{{layoutArea.disableTime}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    export default{
        name: 'swb-retailer-layout-area-detail',
        desc: '布放区详情',
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                layoutArea: {}
            }
        },
        created: function () {
            this.getLayoutAreaDetail();
        },
        methods: {
            getLayoutAreaDetail: function () {
                let self = this;
                //
                let msgBoxDlg = MsgBox.loading();
                merchtComnApi.getRetailerLayoutArea(self.id, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let layoutArea = result.data;
                        //
                        self.layoutArea = Utils.merge({}, layoutArea);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/layoutArea/RetailerLayoutAreaDetail.vue